/*
 * @Author: cc
 * @Date: 2019-12-26 11:46:35
 * @LastEditTime: 2022-01-20 15:01:08
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\kuaishou\signed\signed.js
 * @Description: 快手渠道已签发模块
 */

angular.module('editKuaishouSignedModule', []).controller('EditKuaishouSignedCtrl', [
    '$scope',
    '$state',
    '$controller',
    'modalDialog',
    'editingMediatype',
    'newMediaService',
    'KuaishouConst',
    function(
        $scope,
        $state,
        $controller,
        modalDialog,
        editingMediatype,
        newMediaService,
        KuaishouConst
    ) {
        initStatus();

        /**
         * [initStatus description] 初始化状态
         * @return  {[type]}  [return description]
         */
        function initStatus() {
            $scope.trenchStatus = {
                // eslint-disable-next-line camelcase
                status_model: 2, // 后台用来区分待编、待审、已签发
            };
            $scope.trenchData = {
                trenchConst: KuaishouConst, // 渠道需要的常量
            };
            $scope.trenchParams = {
                serviceid: 'mlf_kuaishou',
                methodName: 'querySigned',
            };
            $scope.distributionMethodName = 'kuaiShouYiQianFaDistribute'; // 多元分发接口名
            $scope.trenchRightsParams = {
                methodname: 'queryOperKeyOfKuaishou',
                Classify: 'kuaishou.yiqianfa',
                // kuaiShouAccountId: $state.params.account,
            };
            $controller('EditShortVideoListCtrl', {$scope: $scope}); // 控制器继承
        }

        /**
         * [retraction description] 取消签发函数
         * @param  {[type]} ChnlDocIds  [description]
         * @param  {[type]} MetaDataIds [description]
         * @param  {[type]} content     [description]
         * @return {[type]}             [description]
         */
        $scope.retraction = function() {
            if ($scope.data.selectedArray.length > 1) {
                modalDialog.alertType('', '每次最多取消签发一个稿件', 'info');
                return;
            }
            newMediaService.retraction($scope, KuaishouConst.retraction);
        };
    },
]);
